import type { EmailMessage } from '@/modules/communications/types/email.types';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/u;

export function validateEmailPayload(message: EmailMessage): {
  valid: boolean;
  reason?: string;
} {
  const recipients = Array.isArray(message.to) ? message.to : [message.to];
  if (!recipients.every((a) => EMAIL_RE.test(a.trim()))) {
    return { valid: false, reason: 'Email inválido' };
  }
  if (!message.subject.trim() || !message.text.trim()) {
    return { valid: false, reason: 'Asunto y cuerpo requeridos' };
  }
  return { valid: true };
}
